import React from "react";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import apiClient from "../api.js";
import Canonical from "../components/Canonical.js";
import { FreeMode, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

const AllBlogs = () => {
  const categories = [
    "general",
    "lifestyle",
    "policies finance",
    "city news",
    "global news",
    "celebrity house",
    "taxation",
    "entertainment",
  ];

  const [blog, setBlog] = useState(null);
  const [category, setCategory] = useState(categories[0]);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const res = await apiClient.get("blog/allblog");
        setBlog(res.data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchBlogs();
  }, []);

  const getCategory = async (cat) => {
    setCategory(cat);
    // console.log(cat);

    try {
      const res = await apiClient.get(
        `blog/category/${encodeURIComponent(cat)}`,
      );
      setBlog(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const canonicalUrl = "https://homesdekho.com/blogs";
  const hrfLangTag = "https://homesdekho.com/blogs";
  const title =
    "HomesDekho Blog - Real Estate Advice, Property Tips & Market Insights";
  const description =
    "Explore the HomesDekho Blog for expert real estate tips, property buying guides, investment advice, home ownership insights, and market trends to help you make smarter property decisions.";

  return (
    <>
      <Canonical
        canonicalUrl={canonicalUrl}
        title={title}
        hrfLang={hrfLangTag}
        description={description}
      />
      <section className="main-region-section mt-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div>
                <h1>HomesDekho Blogs</h1>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <Swiper
                className="region-button"
                spaceBetween={10} // Space between slides
                slidesPerView={"auto"} // Force 8 slides to fit within the first view
                modules={[FreeMode, Navigation]}
                navigation={true}
                style={{
                  padding: "10px 0px", // Padding around text
                }}
              >
                {categories.map((cat) => (
                  <SwiperSlide
                    key={cat}
                    className="area-name-slider"
                    onClick={() => getCategory(cat)}
                    style={{
                      display: "inline-flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "200px",
                      padding: "10px 20px", // Padding around text
                      background: cat === category ? "#032B5F" : "#ffffff",
                      color: cat === category ? "#FFFFFF" : "#000000",
                      border: "1px solid #032B5F",
                      borderRadius: "20px", // Rounded corners
                      whiteSpace: "nowrap", // Prevent text wrapping
                      flexShrink: 0, // Prevent slides from shrinking
                    }}
                  >
                    <div className="text-capitalize">{cat}</div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </section>
      <div className="container mt-3 mb-3">
        <div className="row">
          {blog &&
            blog.map((item) => (
              <div className="col-md-4 mt-3" key={item._id}>
                <div className="card">
                  <img
                    src={item.blogimage}
                    className="card-img-top"
                    alt={item.title}
                  />
                  <div className="card-body">
                    <p className="card-text text-muted">
                      {item.category.toUpperCase()}
                    </p>
                    <h5 className="card-title">{item.title}</h5>
                    <Link
                      to={`/blog-post/${item.slug}`}
                      className="btn btn-primary"
                    >
                      Read More
                    </Link>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

export default AllBlogs;
